import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SoftButton from 'components/SoftButton';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftInput from 'components/SoftInput';



const SpeechToText = ({ onTextChange, promptType, onRecordingStatusChange }) => {
    const [isListening, setIsListening] = useState(false);
    const [text, setText] = useState('');
    const [recognition, setRecognition] = useState(null);
    const [shouldUpdateParent, setShouldUpdateParent] = useState(false);

    useEffect(() => {
      // Whenever isListening changes, inform the parent component
      onRecordingStatusChange(promptType, isListening);
    }, [isListening, onRecordingStatusChange]);

    useEffect(() => {
        // Check for browser support
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (SpeechRecognition) {
            const recognitionInstance = new SpeechRecognition();
            recognitionInstance.continuous = true;
            recognitionInstance.interimResults = true;
            recognitionInstance.onresult = (event) => {
                const transcript = Array.from(event.results)
                    .map(result => result[0])
                    .map(result => result.transcript)
                    .join('');
                setText(transcript);
            };
            setRecognition(recognitionInstance);
        } else {
            console.error('Speech recognition not supported in this browser.');
        }
    }, []);

    useEffect(() => {
      if (shouldUpdateParent) {
          onTextChange(promptType, text);
          setShouldUpdateParent(false); 
      }
    }, [text, promptType, onTextChange, shouldUpdateParent]);

    const startListening = () => {
        if (recognition) {
            recognition.start();
            setIsListening(true);
        }
    };

    const stopListening = () => {
        if (recognition) {
            recognition.stop();
            setIsListening(false);
            setShouldUpdateParent(true);
        }
    };

    const toggleListening = () => {
      if (isListening) {
          stopListening();
      } else {
          startListening();
      }
    };

    useEffect(() => {
      return () => {
          if (recognition) {
              recognition.onresult = null; // Remove the event listener
          }
      };
    }, [recognition]);

    
    const handleSpeechToText = (e) => {
      const recognizedText = e.target.value;
      setText(recognizedText);
      setShouldUpdateParent(true);
      //onTextChange(promptType, recognizedText); 
    };




    return (
      <SoftBox display="flex" flexDirection="column" pt={3} alignItems="center" justifyContent="center">

          <SoftBox display="flex" flexDirection="row" alignItems="center" justifyContent="center" mb={3}>
            <SoftButton variant="outlined" size="small" color={!isListening ? "dark" : "secondary"} onClick={startListening} disabled={isListening}>
              Record
            </SoftButton>
            <SoftButton variant="outlined" size="small" color={isListening ? "dark" : "secondary"} sx={{ ml: 1 }} onClick={stopListening} disabled={!isListening}>
              Stop
            </SoftButton>
          </SoftBox>

    
          <SoftBox sx={{ width: '80%' }} >
            <SoftInput
              value={text}
              multiline
              rows={2}
              onChange={handleSpeechToText} // Allows user to edit the recognized text
              placeholder="Start speaking or type out the changes you want manually. Tell the AI assistant what needs to change, be added, ... "
              fullWidth
            />
          </SoftBox>
    
      </SoftBox>
    );    
};

SpeechToText.propTypes = {
  onTextChange: PropTypes.func.isRequired,
  onRefineNote: PropTypes.func.isRequired,
  promptType: PropTypes.string,
  onRecordingStatusChange: PropTypes.func.isRequired
};

export default SpeechToText;
